import React, { useEffect, useState } from "react";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  Table,
  Spinner,
  FormControl,
  FormSelect,
  Badge,
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import Select from "react-select";
import PubSub from "pubsub-js";
import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/WebRouting";
import trasportApi from "../../api/trasportApi";
import { formatDate, getUserDetails } from "../../utils/helper";
import "./PurchaseOrder.css";
// import { forEach } from "rsuite/esm/internals/utils/ReactChildren";
import Confirm from "../Confirm";
import Main from "../layout/Main";

// Define initial errors i.e. required field and their message
const initialErrors = {
  contact_id: validationMessages.supplier.required,
  financial_year_id: validationMessages.financialYear.required,
};

const initialProductsLineItems = {
  sr_no: 1,
  category_id: null,
  product_id: null,
  packing_size: "",
  gst_type: "",
  gst_amt: 0,
  product_qty: 0,
  purchase_order_id: null,
  owner_id: null,
  sgst: 0,
  supplier_price: 0,
  cgst: 0,
  igst: 0,
};

// const userInfo = getUserDetails();
// console.log(userInfo);
const initialValue = {
  purchase_date: formatDate(new Date()),
  purchase_price: 0,
  //  freight : 0,
  //  insurance : 0,
  //  advance_payment: 0,
  //  advance_percentage :0,
  //  full_payment:0,
  //  pi_amount:0,
  // 'owner_id':userInfo?.id && userInfo.id,
  // 'owner_name':userInfo?.username && userInfo.username,
};

const PurchaseOrderEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // purchaseOrder state
  const [purchaseOrder, setPurchaseOrder] = useState(
    location?.state ? location?.state : initialValue
  );


  //console.log('location?.state',location?.state);
  // const [purchaseOrder, setPurchaseOrder] = useState(
  //   location?.state ?? initialValue
  // );

  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  // useEffect(() => { console.log('errors', errors) }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  // contacts(references)
  const [contacts, setContacts] = useState([]);
  // financial year(references)
  const [financials, setFinancials] = useState([]);
  // Categories
  const [categories, setCategories] = useState([]);

  const [products, setProducts] = useState([]);
  // purchase line items state
  const [purchaseLineItems, setPurchaseLineItems] = useState([]);
  // changed or effected rows state
  const [changedRows, setChangedRows] = useState([]);

  // changed or effected rows state
  const [comparingProducts, setComparingProducts] = useState(null);
  const [showComparingProducts, setShowComparingProducts] = useState(false);
  const [showCompareHelper, setShowCompareHelper] = useState(false);

  const [selectedProductsIds, setSelectedProductsIds] = useState(
    Array.from({ length: products.length }, () => "")
  );

  // delete modal show state
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  // delete record state
  const [deleteRecord, setDeleteRecord] = useState(() => () => { });

  // console.log("purchaseOrder?.purchase_price", purchaseOrder?.purchase_price);

  useEffect(() => {
    function init() {
      fetchContacts();
      fetchProducts();
      fetchedCategories();
      fetchData();
      fetchPurchaseLineItems();
      fetchAllFinancialYears();
    }
    init();
  }, []);

  useEffect(() => {
    setPurchasePrice();
    console.log("purchaseLineItems use Effect call huaa", purchaseLineItems);
  }, [purchaseLineItems]);

  async function fetchContacts() {
    let fetchedContacts = await trasportApi.fetchContacts();
    console.log("fetchedContacts == ", fetchedContacts)
    fetchedContacts = fetchedContacts.filter(con => con.title === "Supplier")
    Array.isArray(fetchedContacts) &&
      setContacts(
        fetchedContacts?.map((fetchedContact) => ({
          id: fetchedContact?.id,
          name: `${fetchedContact?.firstname || ""} ${fetchedContact?.lastname || ""
            }`,
          contactData: fetchedContact,
        }))
      );
  }
  async function fetchAllFinancialYears() {
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });

      const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
      const currentYear = new Date().getFullYear();
      let defaultOption;

      if (currentMonth >= 3) {
        // March is the 3rd month
        defaultOption = ar.find(
          (option) => option.label === `${currentYear}-${currentYear + 1}`
        );
      } else {
        defaultOption = ar.find(
          (option) => option.label === `${currentYear - 1}-${currentYear}`
        );
      }

      if (defaultOption) {
        setSelectedFinancialYear(defaultOption);
        setPurchaseOrder({
          ...purchaseOrder,
          financial_year_id: defaultOption.value,
        });
      } else if (location?.state) {
        const acc = ar.find(
          (acc) => acc.value === location.state.financial_year_id
        );
        setSelectedFinancialYear(acc);
      }
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }
  }
  async function fetchedCategories() {
    const fetchedCategories = await trasportApi.fetchAllCategory();
    console.log("fetchedCategories", fetchedCategories);
    Array.isArray(fetchedCategories) && setCategories([...fetchedCategories]);
  }
  async function fetchProducts() {
    const fetchedProducts = await trasportApi.fetchProducts();
    console.log("fetchedProducts", fetchedProducts);
    Array.isArray(fetchedProducts) && setProducts([...fetchedProducts]);
  }

  const fetchData = async () => {
    if (purchaseOrder?.id && location.hasOwnProperty("pathname")) {
      purchaseOrder.id = location.pathname.split("/")[2];
      let result = await trasportApi.fetchPurchaseOrderById(purchaseOrder.id);
      console.log("result", result);
      if (result) {
        setPurchaseOrder(result);
      } else {
        setPurchaseOrder({});
      }
    }
  };

  async function fetchPurchaseLineItems() {
    if (purchaseOrder?.id) {
      const fetchPurchaseLineItems =
        await trasportApi.fetchPurchaseLineItemsByParentId(purchaseOrder.id);
      Array.isArray(fetchPurchaseLineItems) &&
        setPurchaseLineItems([...fetchPurchaseLineItems]);
    } else {
      setPurchaseLineItems([{ ...initialProductsLineItems }]);
    }
  }

  // onChange Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(e.target);

    if (name == "contact_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.supplier.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    if (name == "financial_year_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.financialYear.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    setValidated(true);
    setPurchaseOrder((prev) => ({ ...prev, [name]: value }));
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;
    console.log("checkRequiredFields == ", purchaseOrder)
    if (purchaseOrder?.contact_id) {
      if (purchaseOrder?.contact_id == "") {
        setErrors((prev) => ({
          ...prev,
          contact_id: { message: validationMessages.supplier.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["contact_id"];
          return { ...prev };
        });
      }
    }
    if (purchaseOrder?.financial_year_id) {
      if (purchaseOrder?.financial_year_id == "") {
        setErrors((prev) => ({
          ...prev,
          financial_year_id: {
            message: validationMessages.financialYear.required,
          },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["financial_year_id"];
          return { ...prev };
        });
      }
    }

    if (!purchaseOrder?.financial_year_id) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please Select FInancial Year",
      });
      isError = true;
    }

    if (!purchaseOrder?.contact_id) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please Select Vendor Name",
      });
      isError = true;
    }



    return isError;
  };


  const checkRequiredLineItemsFileds = () => {
    let isError = false;
    let newErrors = {};
    purchaseLineItems.forEach((item, index) => {
      console.log("item", item);
      if (!item?.category_id) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Required",
          message: validationMessages.categoryName.required,
        });
        //return;
        // alert(validationMessages.categoryName.required);
        isError = true;
      }
      else if (!item?.product_id) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Required",
          message: validationMessages.productName.required,
        });
        isError = true;
      }
      else if (item?.product_qty === 0 || item?.product_qty == "") {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "INVALID",
          message: "Please Provide Valid Product Quantity",
        });
        isError = true;
      }
      else if (item?.supplier_price === 0 || item?.supplier_price == "") {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "INVALID",
          message: "Please Provide Valid  Supplier Price",
        });
        isError = true;
      }
    });
    return isError;
  };

  // PubSub.publish("RECORD_ERROR_TOAST", {
  //   title: "Invalid",
  //   message: "Stock not available",
  // });

  // onSubmit handler
  const handleSubmit = async (e) => {
    const UniqueChangedRows = [...new Set(changedRows.map((item) => item.id))]
      .map((item) => ({ id: item }))
      .concat(
        [...new Set(changedRows.map((item) => item.sr_no))].map((item) => ({
          sr_no: item,
        }))
      );
    console.log("UniqueChangedRows", UniqueChangedRows);

    e.preventDefault();

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (checkRequiredLineItemsFileds()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }
    //Insert purchase Line item
    // console.log('UniqueChangedRows', UniqueChangedRows);
    const record = { ...purchaseOrder };
    delete record.contact_name;
    delete record.financial_name;
    delete record.email;
    delete record.phone;
    delete record.street;

    record.purchase_price = record?.purchase_price ? record.purchase_price : 0;
    record.freight = record?.freight ? record.freight : 0;
    record.insurance = record?.insurance ? record.insurance : 0;
    record.advance_payment = record?.advance_payment
      ? record.advance_payment
      : 0;
    record.advance_percentage = record?.advance_percentage
      ? record.advance_percentage
      : 0;
    record.full_payment = record?.full_payment ? record.full_payment : 0;
    record.pi_amount = record?.pi_amount ? record.pi_amount : 0;
    // //========= Logic to perform Create or Edit ======
    if (record.id) {

      console.log('Updated == ', record);
      const result = await trasportApi.savePurchaseOrder(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        UniqueChangedRows.forEach(async (row) => {
          if (row?.id) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.id == row.id
            );
            console.log("for Update in update", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              recordPurchaseLineItem.purchase_order_id = record.id;
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.images;
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.createdbyname;
              console.log(
                "update case recordPurchaseLineItem ==>",
                recordPurchaseLineItem
              );
              const result = await trasportApi.savePurchaseOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          } else if (row?.sr_no) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.sr_no == row.sr_no
            );
            console.log("for insert in update", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.images;
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.images;
              recordPurchaseLineItem.purchase_order_id = record.id;
              console.log(
                "create recordPurchaseLineItem ==>",
                recordPurchaseLineItem
              );
              const result = await trasportApi.createPurchaseOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          }
        });
        navigate(`${ROUTES.PURCHASE_ORDER.LIST}/${record?.id}`, {
          state: record,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      // console.log('Created');
      const resultPurchaseOrder = await trasportApi.createPurchaseOrder(
        record
      );
      if (resultPurchaseOrder?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        UniqueChangedRows.forEach(async (row) => {
          if (row?.id) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.id == row.id
            );
            console.log("for Update in create", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.image;
              delete recordPurchaseLineItem.sku;
              recordPurchaseLineItem.purchase_order_id = resultPurchaseOrder.id;
              const result = await trasportApi.savePurchaseOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          } else if (row?.sr_no) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.sr_no == row.sr_no
            );
            console.log("for insert in create", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.image;
              delete recordPurchaseLineItem.sku;
              recordPurchaseLineItem.purchase_order_id = resultPurchaseOrder.id;
              const result = await trasportApi.createPurchaseOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          }
        });
        navigate(`${ROUTES.PURCHASE_ORDER.LIST}/${resultPurchaseOrder.id}`, {
          state: resultPurchaseOrder.data,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: resultPurchaseOrder?.errors,
        });
      }
    }
  };

  const handleCancel = () => {
    if (purchaseOrder.id) {
      navigate(`${ROUTES.PURCHASE_ORDER.LIST}/${purchaseOrder.id}`, {
        state: purchaseOrder,
      });
    } else {
      navigate(ROUTES.PURCHASE_ORDER.LIST);
    }
  };
  const addPurchaseLineItems = () => {
    setPurchaseLineItems((prev) => [
      ...prev,
      { ...initialProductsLineItems, sr_no: prev.length + 1 },
    ]);
  };

  const [imagesMap, setImagesMap] = useState({});
  const fetchPrimaryImages = async (e, row) => {
    try {
      if (!row?.product_id) return;
      const productImageResult = await trasportApi.fetchPrimaryImages(
        row.product_id
      );
      if (!productImageResult?.id) return;
      const productImageData = await trasportApi.downloadFiles(
        productImageResult.id,
        "ProductImages"
      );

      if (!productImageData) return;

      const reader = new FileReader();
      reader.readAsDataURL(productImageData);
      reader.onloadend = () => {
        const base64data = reader.result;

        setImagesMap((prev) => ({
          ...prev,
          [row.product_id]: [...(prev[row.product_id] || []), base64data], // Store images per product_id
        }));

        setPurchaseLineItems((prev) =>
          prev.map((purchaseLineItem) =>
            purchaseLineItem.id === row.id
              ? {
                ...purchaseLineItem,
                images: [...(prev[row.product_id] || []), base64data],
              }
              : purchaseLineItem
          )
        );
      };
    } catch (error) {
      console.error("Error fetching image:", error);
    }
  };

  const handlePurchaseLineItemChange = (e, row) => {
    console.log("ROW E", e);
    console.log("row?.product_id", row?.product_id);
    console.log("row?", row);
    console.log("e?.target?.name", e?.target?.name);

    //  if (name == "firstname") {
    //       if (value == "") {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.firstName.required } }));
    //       } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.firstName.invalid } }));
    //       } else {
    //         setErrors((prev) => {
    //           delete prev[name];
    //           return { ...prev };
    //         });
    //       }
    //     }

    // Image  Function Call
    fetchPrimaryImages(e, row);

    if (e?.target?.name) {
      if (row?.id) {
        setPurchaseLineItems((prev) => {
          prev.forEach((purchaseLineItem) => {
            if (purchaseLineItem?.id == row.id) {
              purchaseLineItem[e.target.name] = e?.target?.value;
            }
          });
          return [...prev];
        });
        setChangedRows((prev) => [...prev, { id: row.id }]);
      } else {
        setPurchaseLineItems((prev) => {
          prev.forEach((purchaseLineItem) => {
            if (purchaseLineItem?.sr_no == row.sr_no) {
              purchaseLineItem[e.target.name] = e?.target?.value;
            }
          });
          return [...prev];
        });
        setChangedRows((prev) => [...prev, { sr_no: row.sr_no }]);
      }
    }
  };

  const getPurchasePrice = () => {
    // console.log("getPurchasePrice == ",purchaseLineItems)
    const purchasePriceArr = purchaseLineItems?.map((purchaseLineItem) => {
      // console.log("purchasePriceArr == ",purchasePriceArr)
      if (
        !isNaN(purchaseLineItem?.product_qty) &&
        !isNaN(purchaseLineItem?.supplier_price)
      ) {
        console.log('purchaseLineItem?.product_qty', purchaseLineItem?.product_qty);
        console.log('purchaseLineItem?.supplier_price', purchaseLineItem?.supplier_price);
        return purchaseLineItem?.product_qty * purchaseLineItem?.supplier_price;
      } else {
        return 0;
      }
    });
    if (!Array.isArray(purchasePriceArr) || purchasePriceArr.length === 0) return 0;
    return (
      Array.isArray(purchasePriceArr) &&
      purchasePriceArr.length > 0 &&
      purchasePriceArr?.reduce(
        (prev, value) => value != null && value != undefined && prev + value
      )
    );
    // return purchasePriceArr.reduce((prev, value) => prev + (value || 0), 0);
  };

  const setPurchasePrice = () => {
    const purchasePrice = getPurchasePrice();
    console.log("purchasePrice", purchasePrice);
    purchasePrice != null &&
      purchasePrice != undefined &&
      setPurchaseOrder((prev) => ({ ...prev, purchase_price: purchasePrice }));
  };

  const fetchProductsForCompare = async () => {
    if (purchaseOrder.contact_id) {
      const result = await trasportApi.compareProductsByContactId(
        purchaseOrder.contact_id
      );
      if (!result && result?.errors) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result.errors || "",
        });
      } else {
        setComparingProducts(result);
        setShowComparingProducts(true);
      }
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record Update Error",
        message: "Supplier is required",
      });
    }
  };

  const closeComparePrice = () => {
    setShowComparingProducts(false);
  };

  const onVendorInfoSelect = (e) => {
    const value = e.value;
    const label = e.label;

    const contactData = contacts
      .filter((contact) => contact.id == e.value)
      ?.at(0)?.contactData;

    const purchaseOrder = {};
    purchaseOrder.email = contactData?.email || "";
    purchaseOrder.phone = contactData?.phone || "";
    purchaseOrder.street = contactData?.street || "";

    setPurchaseOrder((prev) => ({ ...prev, ...purchaseOrder }));
    handleChange({ target: { name: "contact_id", value: e.value } });
    handleChange({ target: { name: "contact_name", value: e.label } });
  };

  const purchaseLineItemsHeader = [
    {
      title: "S.No",
      prop: "sr_no",
    },

    {
      title: "Category",
      prop: "category_id",
      cell: (row) => (
        <Form.Group>
          <Select
            required
            className={`${row?.category_id
              ? "custom-select-valid"
              : "custom-select-invalid"
              }`}
            placeholder="Select Category"
            options={categories?.map((category) => ({
              value: category?.id,
              label: category?.name,
            }))}
            onChange={(e) => {
              handlePurchaseLineItemChange(
                { target: { name: "category_id", value: e.value } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "category_name", value: e.label } },
                row
              );
              // Reset product & SKU when category changes
              handlePurchaseLineItemChange(
                { target: { name: "product_id", value: "" } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "product_name", value: "" } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "sku", value: "" } },
                row
              );
            }}
            value={
              row?.category_id
                ? { value: row?.category_id, label: row?.category_name || "" }
                : ""
            }
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </Form.Group>
      ),
    },
    {
      title: "Product",
      prop: "product_id",
      cell: (row) => {
        const filteredProducts =
          products?.filter(
            (product) => product.category_id === row.category_id
          ) || [];
        return (
          <Form.Group>
            <Select
              required
              className={`${row?.product_id
                ? "custom-select-valid"
                : "custom-select-invalid"
                }`}
              placeholder="Select Product"
              options={filteredProducts.map((product) => ({
                value: product?.id,
                label: `${product?.product_name} (${product?.sku})`, // Show product name + SKU
              }))}
              onChange={(e) => {
                const selectedProduct = products.find(
                  (product) => product.id === e.value
                );
                handlePurchaseLineItemChange(
                  { target: { name: "product_id", value: e.value } },
                  row
                );
                handlePurchaseLineItemChange(
                  {
                    target: {
                      name: "product_name",
                      value: selectedProduct?.product_name || "",
                    },
                  },
                  row
                );
                handlePurchaseLineItemChange(
                  {
                    target: { name: "sku", value: selectedProduct?.sku || "" },
                  },
                  row
                );
              }}
              value={
                row?.product_id
                  ? {
                    value: row?.product_id,
                    label: `${row?.product_name} (${row?.sku})`,
                  }
                  : ""
              }
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 1111 }) }}
            />
          </Form.Group>
        );
      },
    },
    {
      title: "Packing Size",
      prop: "packing_size",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            placeholder="Packing Size"
            type="text"
            name={`packing_size`}
            value={row?.packing_size || ""}
            onChange={(e) => {
              handlePurchaseLineItemChange(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    {
      title: "Quantity",//Change name product quantity to quantity by shahir hussain 08-05-2025
      prop: "product_qty",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            required
            className={`${row?.product_id
              ? "custom-select-valid"
              : "custom-select-invalid"
              }`}
            placeholder="Quantity"
            type="number"
            onKeyDownCapture={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            name={`product_qty`}
            value={row?.product_qty}
            onChange={(e) => {
              handlePurchaseLineItemChange(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    // {
    //   title: "Rate Per",
    //   prop: "rate_per",
    //   cell: (row) => (
    //     <Form.Group>
    //       <FormSelect
    //         name="rate_per"
    //         min={0}
    //         max={100}
    //         // value={row.rate_per || ""}

    //         value={row.rate_per || ""}
    //         onChange={(e) => handlePurchaseLineItemChange(e, row)}
    //       >
    //         <option value="">--select--</option>
    //         {["Pcs", "Str", "Cts", "Sets", "Kg/Gram", "Meter/Cm"].map(
    //           (item, index) => (
    //             <option key={index} value={item}>
    //               {item}
    //             </option>
    //           )
    //         )}
    //       </FormSelect>
    //     </Form.Group>
    //   ),
    // },
    //comment this code by shahir hussain 08-05-2025
    // {
    //   title: "SGST",
    //   prop: "sgst",
    //   cell: (row) => (
    //     <Form.Group>
    //       <Form.Control
    //         placeholder="Enter SGST"
    //         onKeyDownCapture={(e) =>
    //           ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    //         }
    //         type="number"
    //         name={`sgst`}
    //         value={row?.sgst}
    //         onChange={(e) => {
    //           handlePurchaseLineItemChange(e, row);
    //         }}
    //       />
    //     </Form.Group>
    //   ),
    // },
    // {
    //   title: "IGST",
    //   prop: "igst",
    //   cell: (row) => (
    //     <Form.Group>
    //       <Form.Control
    //         placeholder="Enter IGST"
    //         onKeyDownCapture={(e) =>
    //           ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    //         }
    //         type="number"
    //         name={`igst`}
    //         value={row?.igst}
    //         onChange={(e) => {
    //           handlePurchaseLineItemChange(e, row);
    //         }}
    //       />
    //     </Form.Group>
    //   ),
    // },
    // {
    //   title: "CGST",
    //   prop: "cgst",
    //   cell: (row) => (
    //     <Form.Group>
    //       <Form.Control
    //         placeholder="Enter CGST"
    //         onKeyDownCapture={(e) =>
    //           ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    //         }
    //         type="number"
    //         name={`cgst`}
    //         value={row?.cgst}
    //         onChange={(e) => {
    //           handlePurchaseLineItemChange(e, row);
    //         }}
    //       />
    //     </Form.Group>
    //   ),
    // },
    {
      title: "Supplier Price",
      prop: "supplier_price",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            required
            className={`${row?.product_id
              ? "custom-select-valid"
              : "custom-select-invalid"
              }`}
            placeholder="supplier price"
            type="number"
            name={`supplier_price`}
            value={row?.supplier_price}
            onKeyDownCapture={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            onChange={(e) => {
              handlePurchaseLineItemChange(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    // {
    //   title: "GST Amount",
    //   prop: "gst_amt",
    //   cell: (row) => (
    //     <Form.Group>
    //       <Form.Control
    //         placeholder="GST Amount"
    //         type="number"
    //         onKeyDownCapture={(e) =>
    //           ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
    //         }
    //         name={`gst_amt`}
    //         value={row?.gst_amt}
    //         onChange={(e) => {
    //           handlePurchaseLineItemChange(e, row);
    //         }}
    //         disabled="true"
    //       />
    //     </Form.Group>
    //   ),
    // },

    {
      title: "Total Price",
      prop: "id",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            disabled
            value={
              (Number(row.product_qty) || 0) * (Number(row.supplier_price) || 0)
            }
          />
        </Form.Group>
      ),
    },
    {
      title: "Price Comparing",
      prop: "id",
      cell: (row) => {
        const comparing_price = comparingProducts?.find(
          (item) => row.product_id === item.product_id
        )?.comparing_price;
        const isExpensive =
          Number(comparing_price) < Number(row?.supplier_price || 0);
        return (
          <Form.Group>
            <Form.Control
              className={`text-white ${isExpensive ? "bg-danger" : "bg-success"
                } bg-gradient`}
              disabled
              value={comparing_price || "0"}
            />
          </Form.Group>
        );
      },
      cellProps: { className: showComparingProducts ? "d-initial" : "d-none" },
      thProps: { className: showComparingProducts ? "d-initial" : "d-none" },
      headerCell: () => (
        <Stack direction="horizontal" gap={1} className="align-items-center">
          <span>Price Comparing</span>
          <OverlayTrigger
            trigger="click"
            placement="top"
            overlay={
              <Popover>
                <Container>This is comparing helper</Container>
              </Popover>
            }
          >
            <i className="fs-5 fa fa-info-circle" aria-hidden="true"></i>
          </OverlayTrigger>
        </Stack>
      ),
    },
    {
      title: "Product Images",
      prop: "images",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "5px",
            flexWrap: "wrap",
            width: "120px",
            height: "100px",
            justifyContent: "center",
          }}
        >
          {imagesMap[row.product_id]?.length > 0 ? (
            <img
              src={
                imagesMap[row.product_id][imagesMap[row.product_id].length - 1]
              } // Show last selected image
              alt="Product Image"
              style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "5px",
              }}
            />
          ) : (
            <span>No Image</span>
          )}
        </div>
      ),
    },
    {
      'title': 'Action', 'prop': 'id', cell: (row) => {
        const deleteCallback = async () => {
          console.log('Deleted ID', row);
          if (row?.id) {
            const result = await trasportApi.deletePurchaseOrderLineItemById(row.id);
            if (result?.success) {
              PubSub.publish("RECORD_SAVED_TOAST", {
                title: "Record Deleted",
                message: "Record successfully deleted",
              });
              fetchPurchaseLineItems();
            }
            else {
              PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Delete Error', message: result?.errors });
            }
          } else if (row?.sr_no) {
            setPurchaseLineItems([...purchaseLineItems.filter((item) => row.sr_no !== item?.sr_no)]);
            PubSub.publish("RECORD_SAVED_TOAST", {
              title: "Record Deleted",
              message: "Record successfully deleted",
            });
          }
          setDeleteModalShow(false);
        }
        return <Button variant="danger" onClick={() => { setDeleteModalShow(true); setDeleteRecord(() => deleteCallback); }}><i className="fa fa-regular fa-trash "></i></Button>
      },
    }
  ];

  useEffect(() => { console.log('deleteRecord', deleteRecord); }, [deleteRecord])

  //FinancialYear
  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setPurchaseOrder({ ...purchaseOrder, financial_year_id: e.value });
  };

  return (
    <>
      <Main>
        <Container className="pb-5">
          {deleteModalShow && <Confirm
            show={deleteModalShow}
            onHide={() => setDeleteModalShow(false)}
            deleteRecord={deleteRecord}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="purchase_line_items"
          />}
          <Row>
            <Col md={12}>
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  onClick={() => navigate(ROUTES.PURCHASE_ORDER.LIST)}
                >
                  Purchase Orders
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col md={12}>
              <Form
                className=""
                onSubmit={() => handleSubmit}
                noValidate
                validated={validated}
              >
                <Card className="shadow">
                  <CardHeader className="card-header" style={{ background: "#1A293B", color: "white" }}>
                    <Row className="w-100">
                      <Col lg={6} className="">
                        <div className="d-flex align-items-center h-100 gap-3">
                          {purchaseOrder?.id ? (
                            <h5 className="m-0">
                              Edit Purchase Order{" "}
                              {purchaseOrder?.purchase_order_no || ""}
                            </h5>
                          ) : (
                            <h5 className="m-0">Create Purchase Order</h5>
                          )}
                        </div>
                      </Col>
                      <Col lg={6} className="p-0">
                        <Stack direction="horizontal" className="float-end" gap={2}>
                          <Button
                            size="sm"
                            className="btn-save"
                            onClick={handleSubmit}
                          >
                            Save
                          </Button>
                          <Button
                            size="sm"
                            className="btn-delete"
                            variant="danger"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                        </Stack>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody className="">
                    <Row lg={12} className="view-form ">
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPurchaseDate"
                          >
                            Purchase Date
                          </Form.Label>
                          <FormControl
                            type="date"
                            name="purchase_date"
                            value={formatDate(purchaseOrder?.purchase_date)}
                            onKeyDown={(e) => e.preventDefault()}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.purchase_date?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicSupplier"
                          >
                            Vendor Name
                          </Form.Label>
                          <Select
                            required
                            className={`${purchaseOrder?.contact_id
                              ? "custom-select-valid"
                              : "custom-select-invalid"
                              }`}
                            placeholder="Select Your Vendor Name"
                            options={contacts?.map((contact) => ({
                              value: contact?.id,
                              label: contact?.name,
                            }))}
                            onChange={(e) => {
                              closeComparePrice();
                              onVendorInfoSelect(e);
                              handleChange({
                                target: { name: "contact_id", value: e.value },
                              });
                              handleChange({
                                target: { name: "contact_name", value: e.label },
                              });
                            }}
                            value={
                              purchaseOrder?.contact_id
                                ? {
                                  value: purchaseOrder?.contact_id || "",
                                  label: purchaseOrder?.contact_name || "",
                                }
                                : ""
                            }
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.contact_id?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group className="">
                          <Form.Label className="form-view-label">
                            Financial Year
                          </Form.Label>
                          <Select
                            required
                            className="custom-select username"
                            placeholder="Select Financial Year"
                            value={selectedFinancialYear}
                            onChange={handlefinancialYear}
                            options={financialYearOption}
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            Please Select Financial Year.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPiNo"
                          >
                            Vendor Address
                          </Form.Label>
                          <FormControl
                            disabled
                            placeholder="Vendor Address"
                            // name="pi_no"
                            value={purchaseOrder.street ? purchaseOrder.street : ""}
                          // onChange={handleChange}
                          />
                          {/* <Form.Control.Feedback type="invalid">
                        {errors?.pi_no?.message}
                      </Form.Control.Feedback> */}
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPiNo"
                          >
                            Vendor Mobile Number
                          </Form.Label>
                          <FormControl
                            disabled
                            placeholder="Vendor Mobile Number"
                            // name="pi_no"
                            value={purchaseOrder.phone ? purchaseOrder.phone : ""}
                          // onChange={handleChange}
                          />
                          {/* <Form.Control.Feedback type="invalid">
                        {errors?.pi_no?.message}
                      </Form.Control.Feedback> */}
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPiNo"
                          >
                            Vendor Email
                          </Form.Label>
                          <FormControl
                            disabled
                            placeholder="Vendor Email"
                            // name="pi_no"
                            value={purchaseOrder?.email}
                          // onChange={handleChange}
                          />
                          {/* <Form.Control.Feedback type="invalid">
                        {errors?.pi_no?.message}
                      </Form.Control.Feedback> */}
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicOrigin"
                          >
                            Origin
                          </Form.Label>
                          <FormControl
                            placeholder="Enter Origin"
                            name="origin"
                            value={purchaseOrder.origin ? purchaseOrder.origin : ""}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.origin?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPurchasePrice"
                          >
                            Purchase Price
                          </Form.Label>
                          <FormControl
                            placeholder="Enter purchase price"
                            disabled
                            name="purchase_price"
                            value={
                              purchaseOrder?.purchase_price != null &&
                                purchaseOrder?.purchase_price != undefined
                                ? purchaseOrder.purchase_price
                                : 0
                            }
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.purchase_price?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPurchasePrice"
                      >
                        Purchase Price
                      </Form.Label>
                      <FormControl
                        placeholder="Enter purchase price"
                        disabled
                        name="purchase_price"
                        value={(purchaseOrder?.purchase_price!=null && purchaseOrder?.purchase_price != undefined)  ? purchaseOrder.purchase_price : 0}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.purchase_price?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicShipment"
                          >
                            Shipment
                          </Form.Label>
                          <FormControl
                            type="date"
                            name="shipment"
                            value={
                              purchaseOrder.shipment
                                ? formatDate(purchaseOrder.shipment)
                                : ""
                            }
                            onChange={handleChange}
                            onKeyDown={(e) => e.preventDefault()}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.shipment?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicInvoiceNo"
                          >
                            Invoice Number
                          </Form.Label>
                          <FormControl
                            placeholder="Enter Invoice Number"
                            name="invoice_no"
                            value={
                              purchaseOrder.invoice_no
                                ? purchaseOrder.invoice_no
                                : ""
                            }
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.invoice_no?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicFreight"
                          >
                            Freight
                          </Form.Label>
                          <FormControl
                            placeholder="Enter Freight Amount"
                            name="freight"
                            value={purchaseOrder.freight}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.freight?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicInsurance"
                          >
                            Insurance
                          </Form.Label>
                          <FormControl
                            placeholder="Enter Insurance Amount"
                            name="insurance"
                            value={purchaseOrder.insurance}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.insurance?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicAdvancePayment"
                          >
                            Advance Payment
                          </Form.Label>
                          <FormControl
                            placeholder="Enter Advance Payment Amount"
                            name="advance_payment"
                            value={purchaseOrder.advance_payment}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.advance_payment?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicAdvancePercentage"
                      >
                        Advance Percentage
                      </Form.Label>
                      <FormControl
                        placeholder="Enter advance payment percentage"
                        name="advance_percentage"
                        value={purchaseOrder.advance_percentage ? purchaseOrder.advance_percentage : ''}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.advance_percentage?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                      {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFullPayment"
                      >
                        Full Payment
                      </Form.Label>
                      <FormControl
                        placeholder="Enter full payment"
                        name="full_payment"
                        value={purchaseOrder.full_payment}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.full_payment?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPaymentStatus"
                          >
                            Payment Status
                          </Form.Label>
                          <FormSelect
                            placeholder="Enter payment status"
                            name="payment_status"
                            value={
                              purchaseOrder.payment_status
                                ? purchaseOrder.payment_status
                                : ""
                            }
                            onChange={handleChange}
                          >
                            <option value="">--select--</option>
                            {["Pending", "Received"]?.map((item, index) => (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            ))}
                          </FormSelect>
                          <Form.Control.Feedback type="invalid">
                            {errors?.payment_status?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPIAmount"
                      >
                        PI Amount
                      </Form.Label>
                      <FormControl
                        placeholder="Enter pi amount"
                        name="pi_amount"
                        value={purchaseOrder.pi_amount ? purchaseOrder.pi_amount : ''}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.pi_amount?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}

                      {/* <Col lg={6}>
                    <Form.Group >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPaymentTerm"
                      >
                        Payment Term
                      </Form.Label>
                      <FormSelect
                        placeholder="Enter payment term"
                        name="payment_term"
                        value={purchaseOrder.payment_term ? purchaseOrder.payment_term : ''}
                        onChange={handleChange}
                      >
                        <option value={''}>--select--</option>
                        {['Pending', 'Received']?.map((item, index) => <option value={item} key={index}>{item}</option>)}
                      </FormSelect>
                      <Form.Control.Feedback type="invalid">
                        {errors?.payment_term?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col> */}
                    </Row>
                    <Row className="pb-1 mt-5">
                      <Col lg={12} className="">
                        <DatatableWrapper
                          body={
                            purchaseLineItems && Array.isArray(purchaseLineItems)
                              ? purchaseLineItems
                              : []
                          }
                          headers={purchaseLineItemsHeader}
                        >
                          <Row className="py-2">
                            <Col
                              lg={12}
                              className="d-flex justify-content-between bg-custom py-2"
                              style={{ background: "#1A293B", color: "white" }}
                            >
                              <h5 className="m-0 p-0">Purchase Line Items</h5>
                              <Stack direction="horizontal" gap={3}>
                                {!showComparingProducts ? (
                                  <Button
                                    size="sm"
                                    variant="success"
                                    onClick={fetchProductsForCompare}
                                  >
                                    Price Comparing
                                  </Button>
                                ) : (
                                  <Button
                                    size="sm"
                                    className="btn-cancel"
                                    onClick={closeComparePrice}
                                  >
                                    Close Price Comparing
                                  </Button>
                                )}
                                <Button
                                  size="sm"
                                  className="btn-save"
                                  onClick={addPurchaseLineItems}
                                >
                                  Add Items
                                </Button>
                              </Stack>
                            </Col>
                          </Row>
                          <Row></Row>
                          <Table
                            striped
                            className="shadow rounded checkin-table"
                            responsive
                          >
                            <TableHeader />

                            {purchaseLineItems &&
                              Array.isArray(purchaseLineItems) ? (
                              <TableBody />
                            ) : (
                              <tbody className="">
                                <tr>
                                  <td colSpan={100} align="center">
                                    <div>
                                      <Spinner />
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </Table>
                        </DatatableWrapper>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </Main>
    </>

  );
};

export default PurchaseOrderEdit;
